import React from 'react';
import { Sparkles, Award, ShieldCheck, Headphones } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const iconMap = { Sparkles, Award, ShieldCheck, Headphones };

const Values = () => {
  const { values = [] } = useSite();
  return (
    <section id="values" className="section pt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v) => {
            const Icon = iconMap[v.icon] || Sparkles;
            return (
              <div
                key={v.title}
                className="rounded-2xl p-6 border border-white/8 bg-white/[0.02] card-lift"
              >
                <div className="h-11 w-11 rounded-xl bg-brand-green/10 border border-brand-green/30 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-brand-green-light" />
                </div>
                <h3 className="mt-5 text-white text-lg font-semibold">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
